import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

export interface CreateGroupDialogData {
  selectedCount: number;
  selectAll?: boolean;
  excludeUserIds?: string[];
  individuallySelectedUsers?: string[];
  isUpdatingGroup?: boolean;
  currentGroupName?: string;
  groupId?: number;
}

export interface CreateGroupDialogResult {
  action: boolean;
  groupName?: string;
  selectAll?: boolean;
  excludeUserIds?: string[];
  individuallySelectedUsers?: string[];
}

@Component({
  selector: 'educare-create-group-dialog',
  templateUrl: './create-group-dialog.component.html',
  styleUrl: './create-group-dialog.component.scss',
  imports: [
    CommonModule,
    FormsModule,
    MatDialogActions,
    MatDialogContent,
    MatDialogTitle,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule
  ]
})
export class CreateGroupDialogComponent {
  public readonly dialogRef = inject(MatDialogRef<CreateGroupDialogComponent>);
  public readonly data = inject<CreateGroupDialogData>(MAT_DIALOG_DATA);

  groupName: string = this.data.isUpdatingGroup && this.data.currentGroupName ? this.data.currentGroupName : '';
  isSubmitting: boolean = false;

  onSubmit(): void {
    // Prevent multiple submissions
    if (this.isSubmitting) {
      return;
    }

    if (this.groupName.trim()) {
      this.isSubmitting = true;
      const result: CreateGroupDialogResult = {
        action: true,
        groupName: this.groupName.trim(),
        selectAll: this.data.selectAll,
        excludeUserIds: this.data.excludeUserIds,
        individuallySelectedUsers: this.data.individuallySelectedUsers
      };
      this.dialogRef.close(result);
    }
  }

  onCancel(): void {
    this.dialogRef.close({ action: false });
  }

  onClose(): void {
    this.dialogRef.close({ action: false });
  }
}
